import React from 'react'

const NotificationBox = props => {
  const { type, title, message, linkText, link, linkSuffix } = props.notification;
  let alertType = '';
  let glyphiconType = '';

  switch (type) {
    case 'success':
      alertType = 'success';
      glyphiconType = 'ok-sign';
      break;
    case 'kubra':
      alertType = 'kubra';
      glyphiconType = 'info-sign';
      break;
    default:
      alertType = 'danger';
      glyphiconType = 'exclamation-sign';
      break;
  }

  return (
    <div className={"notification-box alert alert-" + alertType} role="alert">
      <button
        type="button"
        className="close"
        aria-label="Close"
        onClick={props.hide}
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div className="h3 pull-left">
        <span className={"pull-left glyphicon glyphicon-" + glyphiconType} aria-hidden="true"></span>
        <span className="sr-only">{type}</span>
      </div>
      <p className="h3 text-capitalize"> {title}</p>
      <p className="notification-box-paragraph">{message}
        {linkText === '' ? '' : <a href={link}>{linkText}</a>}
        {linkSuffix === '' ? '' : linkSuffix} </p>
    </div>
  )
}

export default NotificationBox;